import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowsMinimizeIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrows-minimize"><g id="Icon"><path d="M13.7 4C14.197 4 14.6 4.40294 14.6 4.9V8.12721L19.4636 3.2636C19.8151 2.91213 20.3849 2.91213 20.7364 3.2636C21.0879 3.61508 21.0879 4.18492 20.7364 4.5364L15.8728 9.4H19.1C19.597 9.4 20 9.80294 20 10.3C20 10.7971 19.597 11.2 19.1 11.2H13.7C13.2029 11.2 12.8 10.7971 12.8 10.3V4.9C12.8 4.40294 13.2029 4 13.7 4Z" fill="currentColor" /><path d="M9.4 15.8728L4.5364 20.7364C4.18492 21.0879 3.61508 21.0879 3.2636 20.7364C2.91213 20.385 2.91213 19.8151 3.2636 19.4637L8.12721 14.6H4.9C4.40294 14.6 4 14.1971 4 13.7C4 13.203 4.40294 12.8 4.9 12.8H10.3C10.7971 12.8 11.2 13.203 11.2 13.7V19.1C11.2 19.5971 10.7971 20 10.3 20C9.80294 20 9.4 19.5971 9.4 19.1V15.8728Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowsMinimizeIcon;